
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ComModelParams extends Vue {
  @Prop({ default: () => ({}), type: Object }) modelData: any;
  get paramsList() {
    return Object.entries(this.modelData?.modelDetail || {});
  }
}
